import { render, staticRenderFns } from "./DragNDropPad.vue?vue&type=template&id=d45d1686&scoped=true&"
import script from "./DragNDropPad.vue?vue&type=script&lang=js&"
export * from "./DragNDropPad.vue?vue&type=script&lang=js&"
import style0 from "./DragNDropPad.vue?vue&type=style&index=0&id=d45d1686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45d1686",
  null
  
)

export default component.exports